// src/modules/gyms/components/branch-page/BranchAmenities.tsx
import { AMENITIES_LIST } from "../../models/gym.model";

interface BranchAmenitiesProps {
  amenities: string[];
}

export const BranchAmenities = ({ amenities }: BranchAmenitiesProps) => {
  if (amenities.length === 0) {
    return (
      <div className="card border-0 shadow-sm p-4 text-center text-muted">
        <p className="mb-0" style={{ fontSize: "0.95rem" }}>
          Chưa có tiện ích nào.
        </p>
      </div>
    );
  }

  const getAmenityLabel = (id: string) => {
    const found = AMENITIES_LIST.find((a) => a.id === id);
    return found ? found.label : id;
  };

  return (
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body">
        <h6 className="fw-bold mb-3" style={{ fontSize: "1.15rem" }}>
          Tiện ích
        </h6>
        <div className="row g-1">
          {amenities.map((id) => (
            <div key={id} className="col-6">
              <div
                className="d-flex align-items-center gap-2 py-1 text-secondary"
                style={{ fontSize: "1rem" }}
              >
                <i
                  className="bi bi-check-circle-fill text-secondary flex-shrink-0"
                  style={{ fontSize: "1.1rem" }}
                />
                <span>{getAmenityLabel(id)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
